import { Controller } from "stimulus";
import { submitForm } from "init/ajax";

export default class extends Controller {
  static targets = ["form", "submit"];

  connect() {
    this.originalForm = this.formTarget.innerHTML;
  }

  submit(event) {
    event.preventDefault();
    event.returnValue = false;

    submitForm(this.formTarget).then(response => {
      var messageElement = document.createElement('div');

      if (response.success) {
        this.formTarget.innerHTML = this.originalForm;

        messageElement.classList.add('Contact__success-message')
        messageElement.innerText = "Success!"

        document.querySelector('.Contact__form-submit').insertAdjacentElement('afterend', messageElement)

      } else {
        messageElement.classList.add('Contact__error-message')
        messageElement.innerText = "Please contact customer support"
      }
    });
  }
}
